import { getDefaultLoader, extendLoader, } from 'piral-base';
import { globalDependencies } from './modules';
import { integrateDebugger, integrateEmulator } from '../app.codegen';
export function createPiletOptions({ hooks, context, loaders, loaderConfig, availablePilets, strategy, createApi, loadPilet, requestPilets, shareDependencies, debug, }) {
    const options = {
        config: loaderConfig,
        strategy,
        loadPilet: extendLoader(loadPilet ?? getDefaultLoader(loaderConfig), loaders),
        createApi,
        pilets: availablePilets,
        fetchPilets: requestPilets,
        hooks,
        dependencies: shareDependencies(globalDependencies),
    };
    integrateDebugger(context, options, debug);
    integrateEmulator(context, options, debug);
    return options;
}
//# sourceMappingURL=helpers.js.map